export const types = {
    iniciar:  '[Aut] Iniciar Sesion',
    cerrar:   '[Aut] Cerrar Sesion',
}